import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import { CmsArea, CmsContentPipe } from '@domgen/dgx-fe-cms';
import { AlertComponent } from '@domgen/dgx-fe-components/alert';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { IneligibleComponentService } from '../../services/ineligible/ineligible-component.service';

@Component({
  templateUrl: './ineligible.component.html',
  styleUrls: ['./ineligible.component.scss'],
  providers: [IneligibleComponentService],
  standalone: true,
  imports: [
    AlertComponent,
    AsyncPipe,
    CmsContentPipe,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
  ],
})
@GAPage()
export class IneligibleComponent {
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: IneligibleComponentService) {}
}
